export default "__VITE_ASSET__BRyqVZKS__"